export const SDK_VERSION = '7.77.0';
